import { Variable, all, not, Div, Span, TD, if as _if, TH } from 'alkali'
import { toRowConfigLabel } from 'components/extract/RowComponents'
import { BinaryValueField, CountValueField, ContinuousSDExtractField, ContinuousValueExtractField } from 'components/extract/Inputs'
import { EGroup, FieldType, STUDY_LEVEL_GRP } from 'services/extract/types'

const valueInputs = ({ row, group, type, isPctChange, effUnit, rowComponent, focusedState, cls }) => {
	if (row) {
		const unit = row.unit
		const devType = row.devType
		const obj = row.cells.property(group?.id || STUDY_LEVEL_GRP)
		if (type == FieldType.CONTINUOUS) {
			return {
				value: new ContinuousValueExtractField(cls, {
					obj,
					syncUnit: {
						var: unit,
						setValue: v => {
							unit.put(v)
							rowComponent.setUnit(v)
						}
					},
					assignUnit: not(isPctChange),
					focusedState
				}),
				modifier: new ContinuousSDExtractField(cls, {
					obj,
					devType,
					focusedState
				}),
				unit: Div('.extract-field', [
					Div('.extract-simple', [
						Div('.unit-label.text-wrap', { title: effUnit }, effUnit)
					])
				])
			}
		} else if (type == FieldType.BINARY) {
			const curUnit = unit.valueOf()
			// if we are switching to binary and we have an invalid/continuous unit, reinitialize to default
			if (!!curUnit && curUnit != '%') unit.put(undefined)
			return {
				value: new BinaryValueField(cls, {
					obj,
					focusedState,
					unit
				}),
				unit: Div('.extract-field', [
					Div('.extract-simple', [
						Div('.unit-label.text-wrap', { title: rowComponent.binaryPctToggle.binaryUnitLabel }, rowComponent.binaryPctToggle.binaryUnitLabel)
					])
				])
			}
		} else if (type == FieldType.COUNT) {
			return {
				value: new CountValueField(cls, {
					obj,
					focusedState,
					unit
				}),
				unit: Div('.extract-field', [
					Div('.extract-simple', [
						Div('.text-wrap', '#')
					])
				])
			}
		}
	} else {
		return [Span('.text-muted', '-')]
	}
}

export const CellInputs = ({ group, row, type, isPctChange, effUnit, rowComponent, focusedState }) => {
	return all([group, type], (group: EGroup, type) =>
		valueInputs({ row, group, type, isPctChange, effUnit, rowComponent, focusedState, cls: '.outcome-value' })
	)
}

export const CellSpacers = row => {
	const ctns = row.type.to(t => t as unknown as FieldType == FieldType.CONTINUOUS)
	return [
		TD({ attributes: { colspan: _if(ctns, [1, 2]) }}),
		TD({ classes: { hidden: not(ctns) }}),
		TD()
	]
}

export const CellHeaders = (row, rowComponent, rowTypeTitle = 'Row') => {
	const ctns = row.type.to(t => t as unknown as FieldType == FieldType.CONTINUOUS)
	return [
		TH('.outcome-value-hdr', { attributes: { scope: 'col', colspan: _if(ctns, [1, 2]) }, title: row.type.to(t => `${t} ${rowTypeTitle}`) }, toRowConfigLabel(row)),
		TH('.outcome-mod-hdr', { attributes: { scope: 'col' }, title: rowComponent.devTypeToggle.title, classes: { hidden: not(ctns) } },
			rowComponent.devTypeToggle.element
		),
		TH('.outcome-unit-hdr', { attributes: { scope: 'col' }, title: rowComponent.binaryPctToggle.title },
			rowComponent.binaryPctToggle.element
		)
	]
}

export const CellCells = (cellInputs, rowCount = new Variable(1), render = true) => {
	if (!render) return []
	const hasModifier = cellInputs.property('modifier')
	return [
		TD({ attributes: { colspan: _if(hasModifier, [1,2]), rowspan: rowCount } }, cellInputs.to(({value}) => value)),
		TD({ classes: { hidden: not(cellInputs.property('modifier')) }, attributes: { rowspan: rowCount } },
			cellInputs.to(({modifier}) => modifier)),
		TD('.outcome-unit-cell', { attributes: { rowspan: rowCount } }, cellInputs.to(({unit}) => unit))
	]
}
